import InputWithLengthLimit from './input_with_length_limit/input_with_length_limit_unpoly'

up.compiler('.js-input_with_length_limit', function (element) {
  new InputWithLengthLimit(element)
})
